import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const CalendarDateString = z.codec(
  z.iso.date(),
  z.instanceof(Temporal.PlainDate),
  {
    decode: (isoDate) =>
      Temporal.PlainDate.from(isoDate, { overflow: 'reject' }),
    encode: (plainDate) => plainDate.toString({ calendarName: 'never' }),
  },
);

export const InstantString = z.codec(
  z.iso.datetime({ offset: true }),
  z.instanceof(Temporal.Instant),
  {
    decode: (dateTime) => Temporal.Instant.from(dateTime),
    encode: (instant) => instant.toString(),
  },
);

export const DeliveryDate = CalendarDateString.brand<'DeliveryDate'>();
export type DeliveryDate = z.infer<typeof DeliveryDate>;

export const ContractStartDate =
  CalendarDateString.brand<'ContractStartDate'>();
export type ContractStartDate = z.infer<typeof ContractStartDate>;

export const ContractExpiryDate =
  CalendarDateString.brand<'ContractExpiryDate'>();
export type ContractExpiryDate = z.infer<typeof ContractExpiryDate>;

export const ContractRegistrationDate =
  CalendarDateString.brand<'ContractRegistrationDate'>();

export const ContractCancellationDate =
  CalendarDateString.brand<'ContractCancellationDate'>();
export type ContractCancellationDate = z.infer<typeof ContractCancellationDate>;

export const CustomerBuildDate =
  CalendarDateString.brand<'CustomerBuildDate'>();

export const CustomerLastChangedDate =
  CalendarDateString.brand<'CustomerLastChangedDate'>();

export const WarrantyStartDate =
  CalendarDateString.brand<'WarrantyStartDate'>();

export const PaymentInvoiceDate =
  CalendarDateString.brand<'PaymentInvoiceDate'>();

export const PaymentDueDate = CalendarDateString.brand<'PaymentDueDate'>();
export type PaymentDueDate = z.infer<typeof PaymentDueDate>;

export const PaymentReceivedDate =
  CalendarDateString.brand<'PaymentReceivedDate'>();

export const LastRecordedAt = InstantString.brand<'LastRecordedAt'>();
